import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Radio as RadioBase, RadioProps } from '@mui/material';
import { ReactComponent as RadioCheckedIcon } from '../../assets/radio-checked.svg';
import { ReactComponent as RadioIcon } from '../../assets/radio.svg';
import { componentToken } from '../../style/utils';

const StyledRadio = styled(RadioBase)`
  &.MuiRadio-root {
    ${({ disabled, theme }) =>
      disabled && `opacity: ${theme.tokens.components.radio.disabledOpacity}`};
    :hover {
      background: none;
    }
  }

  [class$='radio-ring'] {
    fill: ${componentToken('radio.ring')};
  }

  [class$='radio-checked-ring'],
  [class$='radio-dot'] {
    fill: ${componentToken('radio.checked')};
  }

  &.Mui-disabled {
    [class$='radio-ring'] {
      fill: ${componentToken('radio.disabledRing')};
    }

    [class$='radio-checked-ring'],
    [class$='radio-dot'] {
      fill: ${componentToken('radio.disabledChecked')};
    }
  }
`;

const Radio = forwardRef((props: RadioProps, ref: any) => (
  <StyledRadio
    ref={ref}
    {...props}
    icon={<RadioIcon />}
    checkedIcon={<RadioCheckedIcon />}
  />
));

export default Radio;
